import { Import } from 'lucide-vue-next'
import { defineStore } from 'pinia'
import { useAuthStore } from '@/auth/auth'
import { ApiSup } from "@/Functions/ApiSupport";
import axios from 'axios'

export const usedStaffStore = defineStore('staffStore', {
  state: () => ({
    staffs: [],
    staff: [],
    teaching: [],
    nonteaching: [],
    staffPerSchool: [],
    staffRights: [],
    staffCustID: '',
    staffCount: 0,
    forRetireCount: 0,
    accordion: {}
  }),
  getters: {
    getStaffById: (state) => (id) => {
      return state.staffs.find((staff) => staff.id === id) || null
    },
  },
  actions: {
    // ADD STAFF
    async addStaff(staff) {
      const authStore = useAuthStore()
      try {
        const res = await fetch(`${import.meta.env.VITE_HOST_API}/api/staff/`, {
          method: 'POST',
          body: staff,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authStore.token}`,
          },
        })
        const data = await res.json() // ✅ Parse response first

        console.log(JSON.stringify(data))
        if (!res.ok) {
          // console.error('Server error:', data)
          return { success: false, error: data }
        }

        // ✅ Only refresh data after successful operation
        await this.fetchData()

        return { success: true, data }
      } catch (err) {
        // console.error('Network error:', err)
        return { success: false, error: err }
      }
    },

    // INSERT EMPLOYMENT DETAILS
    async addEmploymentDetails(emp, pid) {
      const authStore = useAuthStore()
      emp.employmentDetails.awards = emp.employmentDetails.awards.join(', ')
      emp.employmentDetails.prof_dev = emp.employmentDetails.prof_dev.join(', ')

      let signatureString = ''

      if (emp.info) {
        Object.values(emp.info).forEach((value) => {
          if (value) signatureString += value.toString().trim() + ''
        })
      }

      if (emp.employmentDetails) {
        Object.values(emp.employmentDetails).forEach((value) => {
          if (value) signatureString += value.toString().trim() + ''
        })
      }

      emp.signature = authStore.hashText(signatureString)


      //const res = await fetch('http://localhost:8080/api/staff/' + pid, {
      const res = await fetch(`${import.meta.env.VITE_HOST_API}/api/staff/` + pid, {
        method: 'PUT',
        body: JSON.stringify(emp),
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${authStore.token}` },
      })
      this.fetchByID(pid)
      if (!res.ok) {
        const errorData = await res.json()
        return { success: false, error: errorData.errors }
      } else {
        return { success: true, data: res }
      }
    },

    // updateMainInfo
    async updateMainInfo(emp, pid) {
      const authStore = useAuthStore()

      let signatureString = ''
      if (emp.info) {
        Object.values(emp.info).forEach((value) => {
          if (value) signatureString += value.toString().trim() + ''
        })
      }

      if (emp.addressInfo) {
        Object.values(emp.addressInfo).forEach((value) => {
          if (value) signatureString += value.toString().trim() + ''
        })
      }



      // Object.entries(emp).forEach(([key, value]) => {
      //   if (key !== 'addressInfo' && key !== 'info' && key !== 'signature' && value) {
      //     if (typeof value !== 'object') {
      //       signatureString += value.toString().trim() + ' '
      //     }
      //   }
      // })

      emp.signature = authStore.hashText(signatureString)

      //const res = await fetch('http://localhost:8080/api/staff/' + pid, {
      const res = await fetch(`${import.meta.env.VITE_HOST_API}/api/staff/` + pid, {
        method: 'PUT',
        body: JSON.stringify(emp),
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${authStore.token}` },
      });
      this.fetchByID(pid)
      if (!res.ok) {
        const errorData = await res.json()
        // console.error('Server error:', errorData)
      } else {
        return { success: true, data: res }
      }
    },

    //INSERT OTHER INFO
    async addOtherInfoDetails(newStaff, pid) {
      const authStore = useAuthStore()
      if (newStaff.others.background_check === 'Done') {
        newStaff.others.background_check = '1'
      } else {
        newStaff.others.background_check = '0'
      }
      newStaff.others.certification = newStaff.others.certification.join(', ')
      newStaff.others.educational_attainment = newStaff.others.educational_attainment.join(', ')
      newStaff.others.specialization = newStaff.others.specialization.join(', ')
      newStaff.others.supervisory_responsibilities =
        newStaff.others.supervisory_responsibilities.join(', ')
      newStaff.others.language = newStaff.others.language.join(', ')


      let signatureString = ''

      if (newStaff.info) {
        Object.values(newStaff.info).forEach((value) => {
          if (value) signatureString += value.toString().trim() + ''
        })
      }

      if (newStaff.others) {
        Object.values(newStaff.others).forEach((value) => {
          if (value) signatureString += value.toString().trim() + ''
        })
      }

    //  console.log( JSON.stringify(newStaff))

      newStaff.signature = authStore.hashText(signatureString)

      //const res = await fetch('http://localhost:8080/api/staff/' + pid, {
      const res = await fetch(`${import.meta.env.VITE_HOST_API}/api/staff/` + pid, {
        method: 'PUT',
        body: JSON.stringify(newStaff),
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${authStore.token}` },
      })
      this.fetchByID(pid)

      if (!res.ok) {
        const errorData = await res.json()
        return { success: false, error: errorData.errors }
      } else {

        return { success: true, data: res }
      }
    },
    // GET ALL
    async fetchData(dept,emp,rankx) {

      const authStore = useAuthStore()
      const params = {
        department: dept,
        employment: emp,
        rank: rankx
      }

      const res = await fetch(`${import.meta.env.VITE_HOST_API}/api/staff/`, {
        params: params,
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      })
      const data = await res.json()

      this.staffs = Object.fromEntries(data.data.map((staff) => [staff.pid, staff]))
      this.staffs = data.data
    },

    async fetchDataWithFilter(dept, emp, rankx) {
      const authStore = useAuthStore()

      const queryParams = new URLSearchParams({
        department: dept,
        employment: emp,
        rank: rankx
      });

      const baseUrl = `${import.meta.env.VITE_HOST_API}/api/staff/`;
      const urlWithParams = `${baseUrl}?${queryParams.toString()}`;

      const res = await fetch(urlWithParams, {
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      });

      const data = await res.json();

      this.staffs = data.data;
    },
    async perschoolfetchDataWithFilter(dept, emp, rankx, school_id) {
      const authStore = useAuthStore()

      const queryParams = new URLSearchParams({
        department: dept,
        employment: emp,
        rank: rankx,
        school_id: school_id
      });

      const baseUrl = `${import.meta.env.VITE_HOST_API}/api/staff/`;
      const urlWithParams = `${baseUrl}?${queryParams.toString()}`;

      const res = await fetch(urlWithParams, {
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      });

      const data = await res.json();

      this.staffPerSchool = data.data;
    },

        async getAccordion(userPID,schoolPID){
                const apiSup = ApiSup()
                const ret = await apiSup.getSupport('api/counts/staffRanksForRetirement/' + userPID + '/' + schoolPID)
                this.accordion = ret

                let count = 0;

                if (this.accordion.forRetirement && this.accordion.forRetirement.length > 0) {
                  // First, calculate the total count using forEach
                  this.accordion.forRetirement.forEach(item => {
                    count += item.count;
                  });
                }
                this.forRetireCount = count
        },

async getTeacherCount(userPID,schoolPID){

          const transformTeachingData = (apiResponse) => {
    const transformedStaff = [];

    apiResponse.teacher.forEach(school => {
        const schoolInfo = {
            pid: school.pid,
            name: school.name,
            address1: school.address1,
            address2: school.address2,
            city: school.city,
            country: school.country,
            zip_code: school.zip_code,
            school_type_id: school.school_type_id,
            head_officer: school.head_officer,
            area_size: school.area_size,
            level: school.level,
            phone_number: school.phone_number,
            email: school.email,
            website_url: school.website_url,
            division: school.division,
            accreditation: school.accreditation,
            acronym: school.acronym,
            status: school.status,
            date_founded: school.date_founded,
            division_id: school.division_id,
            photo: school.photo
        };

        school.staff.forEach(staffMember => {
            transformedStaff.push({
                ...staffMember,
                school: schoolInfo
            });
        });
    });

    return transformedStaff;
};

// Transform function for TEACHING data (school name only)
const transformTeachingDataWithNameOnly = (apiResponse) => {
    const transformedStaff = [];

    apiResponse.teacher.forEach(school => {
        school.staff.forEach(staffMember => {
            transformedStaff.push({
                ...staffMember,
                school: {
                    name: school.name
                }
            });
        });
    });

    return transformedStaff;
};


      const authStore = useAuthStore()

       const params = {
        schools: schoolPID
      }
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_HOST_API}/` + 'api/counts/teacherCount/' + userPID,
          {
            params: params,
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${authStore.token}`,
            }
          }
        )
                this.teaching = transformTeachingData(response.data)


      } catch (error) {
        console.error('Error transformTeachingData:', error)
        throw error
      }

        },

        async getNonTeachingCount(userPID,schoolPID){
                  const transformNonTeachingData = (apiResponse) => {
            const transformedStaff = [];

            // Iterate through each school in the nonTeaching array
            apiResponse.nonTeaching.forEach(school => {
                // Extract school information (excluding the staff array)
                const schoolInfo = {
                    pid: school.pid,
                    name: school.name,
                    address1: school.address1,
                    address2: school.address2,
                    city: school.city,
                    country: school.country,
                    zip_code: school.zip_code,
                    school_type_id: school.school_type_id,
                    head_officer: school.head_officer,
                    area_size: school.area_size,
                    level: school.level,
                    phone_number: school.phone_number,
                    email: school.email,
                    website_url: school.website_url,
                    division: school.division,
                    accreditation: school.accreditation,
                    acronym: school.acronym,
                    status: school.status,
                    date_founded: school.date_founded,
                    division_id: school.division_id,
                    photo: school.photo
                };

                // Add each staff member with school information
                school.staff.forEach(staffMember => {
                    transformedStaff.push({
                        ...staffMember,
                        school: schoolInfo
                    });
                });
            });

            return transformedStaff;
        };

      const authStore = useAuthStore()

       const params = {
        schools: schoolPID
      }
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_HOST_API}/` + 'api/counts/nonTeachingCount/' + userPID,
          {
            params: params,
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${authStore.token}`,
            }
          }
        )

        // Transform the data
        const transformedData = transformNonTeachingData(response.data);
        this.nonteaching = transformedData;

      } catch (error) {
        console.error('Error transformNonTeachingData:', error)
        throw error
      }


        // Alternative: If you want just the school name instead of full school object
        const transformNonTeachingDataWithNameOnly = (apiResponse) => {
            const transformedStaff = [];

            apiResponse.nonTeaching.forEach(school => {
                school.staff.forEach(staffMember => {
                    transformedStaff.push({
                        ...staffMember,
                        school: {
                            name: school.name
                        }
                    });
                });
            });

            return transformedStaff;
        };
        },
    //UPDATE CHANGES
    async updateAll(emp, pid) {
      const authStore = useAuthStore()
      //const res = await fetch('http://localhost:8080/api/staff/' + pid, {
      const res = await fetch(`${import.meta.env.VITE_HOST_API}/api/staff/` + pid, {
        method: 'PUT',
        body: emp,
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${authStore.token}` },
      })
      this.fetchByID(pid)
      if (!res.ok) {
        const errorData = await res.json()
        // console.error('Server error:', errorData)
      } else {
        return { success: true, data: res }
      }
    },

    // GET BY ID
    async fetchBySchoolId(pid, sh) {

      const authStore = useAuthStore()
      //const res = await fetch('http://localhost:8080/api/schools/' + pid+ '/staff/')
      const res = await fetch(`${import.meta.env.VITE_HOST_API}/api/schools/` + pid + `/staff/`, {
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      })
      const data = await res.json()
      this.staffPerSchool = data.data.record
      this.staffCount = data.data.total
    },

    // GET BY ID
    async fetchByID(pid) {
      // console.log(pid)
      const authStore = useAuthStore()
      // const res = await fetch('http://localhost:8080/api/staff/' + pid)
      const res = await fetch(`${import.meta.env.VITE_HOST_API}/api/staff/` + pid, {
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      })
      // console.log(JSON.stringify(res))
      const data = await res.json()
      this.staff = data.data
      // console.log(JSON.stringify(this.staff))

        this.staffCustID = data.customize_role_access_pid
        this.staffRights = data.roles
    },

    async deleteStaff(id){
      const apiSup = ApiSup()
      const ret = await apiSup.deleteSupport('api/staff/' + id)
       if (ret === 'success'){
        await this.fetchData()
        return { success: true }
      }else{
        return {success: false}
      }

    },

    // addstaff(staff) {
    //   this.staffs.push(staff)
    // },
    updateStaff(updatedStaff) {
      const index = this.staffs.findIndex((staff) => staff.id === updatedStaff.id)
      if (index !== -1) {
        this.staffs[index] = { ...updatedStaff }
        return true
      }
      return false
    },
    updateEmploymentInfo(staffId, newEmploymentInfo) {
      const staff = this.staffs.find((staff) => staff.id === staffId)
      if (staff) {
        staff.employmentInfo = { ...staff.employmentInfo, ...newEmploymentInfo }
      }
    },
    updateAddInfo(staffId, newAdditionalInfo) {
      const staff = this.staffs.find((staff) => staff.id === staffId)
      if (staff) {
        staff.additionalInfo = { ...staff.additionalInfo, ...newAdditionalInfo }
      }
    },
  },
})
